const client = require("contentful").createClient({
  space: "m2n3283ys9f6",
  accessToken: "KNC8garK9nxzIN-fCJjPt5KPoZKZKD3CVDeLB4WCLhg",
});

const getBlogPosts = () =>
  client.getEntries().then((response) => response.items);

const getSinglePost = (slug) =>
  client
    .getEntries({
      "fields.slug": slug,
      content_type: "blogPost",
    })
    .then((response) => response.items);

export { getBlogPosts, getSinglePost };
